import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { perfil } from 'src/app/models/perfil';
import { AlertifyService } from 'src/app/services/alertify.service';
import { ProfileService } from 'src/app/services/profile.service';
import { UserService } from 'src/app/services/user.service';

import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';

import * as _moment from 'moment';
import { default as _rollupMoment, Moment } from 'moment';
import { ConfiguracionService } from 'src/app/services/configuracion.service';
const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-create-edit-deportista',
  templateUrl: './create-edit-deportista.component.html',
  styleUrls: ['./create-edit-deportista.component.scss'],
  providers: [{ provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }],
})
export class CreateEditDeportistaComponent implements OnInit {
  public documentos: any;
  public perfiles: perfil[];
  registerForm: UntypedFormGroup;
  public isForEdit = false;
  public dataInput: any;
  public tituloTxt = 'Crear deportista';
  

  constructor(
    public perfilSvc: ProfileService,
    public configSvc: ConfiguracionService,
    public usrSvc: UserService,
    private alertify: AlertifyService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<CreateEditDeportistaComponent>
  ) {
    this.dataInput = data;
  //  console.log('los datos de ingreso son: ', data);
    if (data != null) {
      this.isForEdit = true;
      this.tituloTxt = 'Editar deportista';
    }
  }

  ngOnInit(): void {

  this.inicarFormulario();

  }

  inicarFormulario() {
    this.registerForm = new UntypedFormGroup({
      id: new UntypedFormControl(''),
      nombre: new UntypedFormControl('', Validators.required),
      tipoDocumento: new UntypedFormControl('', Validators.required),
      documento: new UntypedFormControl('', [
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(15),
        Validators.min(1),
        Validators.pattern('^[A-Za-z0-9]+$'),
      ]),
      email: new UntypedFormControl('', Validators.required),
      celular: new UntypedFormControl('', [Validators.pattern('[0-9]*'), Validators.required]),
      //   estado: new FormControl('', Validators.required),
      contactoNombre: new UntypedFormControl('',Validators.required),
      //contactoDocumento: new UntypedFormControl(''),
      contactoTelefono: new UntypedFormControl('',Validators.required),
      direccion: new UntypedFormControl(''),
      telefono: new UntypedFormControl(''),
      eps: new UntypedFormControl('', Validators.required),
      fechaNacimiento: new UntypedFormControl(''),
      rh: new UntypedFormControl(''),
      sexo: new UntypedFormControl(''),
    });


    // this.registerForm.get('estado')?.setValue(1);

    this.documentos = [
      { value: 1, nombre: 'CC' },
      { value: 2, nombre: 'Pasaporte' },
      { value: 3, nombre: 'NIT' },
      { value: 4, nombre: 'C. Extranjeria' },
      { value: 5, nombre: 'TI' },
      { value: 6, nombre: 'Registro civil' },
    ];
    this.registerForm.get('sexo')?.setValue('0');
    this.perfilSvc.getPerfilesEmpleados().subscribe((y) => {
      this.perfiles = y;
      if (this.dataInput != null) {
        this.registerForm.get('id')?.setValue(this.dataInput.id);
        this.registerForm.get('nombre')?.setValue(this.dataInput.nombre);
        this.registerForm
          .get('tipoDocumento')
          ?.setValue(this.dataInput.tipoDocumento);
        this.registerForm.get('documento')?.setValue(this.dataInput.documento);
        this.registerForm.get('email')?.setValue(this.dataInput.email);
        this.registerForm.get('celular')?.setValue(this.dataInput.celular);
      
        //aqui debe ir al backend por la info del usuario y llenarla
   

        this.usrSvc.getDetalleUsuario(this.dataInput.id).subscribe((x) => {
          console.log('datos detalle usuario: ', x);
          if (this.dataInput != null) {
            this.registerForm.get('contactoNombre')?.setValue(x.contactoNombre);
            this.registerForm.get('contactoDocumento')?.setValue('');
            this.registerForm
              .get('contactoTelefono')
              ?.setValue(x.contactoTelefono);
            this.registerForm.get('direccion')?.setValue(x.direccion);
            this.registerForm.get('telefono')?.setValue(x.telefono);
            this.registerForm.get('eps')?.setValue(x.eps);
        /*      this.registerForm
              .get('fechaNacimiento')
              ?.setValue(x.fechaNacimiento); */
            this.registerForm.get('rh')?.setValue(x.rh);
            this.registerForm.get('sexo')?.setValue(x.sexo + '');
         
            if(x.fechaNacimiento!=null){
              let date= new Date(x.fechaNacimiento);
             // console.log('DIAAAAAAAAAA: ',date.getDate());
              let mes=date.getMonth()+1;
              let mesCadena=mes<10?'0'+mes:mes+"";
            //  this.registerForm.get('fechaNacimiento')?.setValue(date.getFullYear()+'-'+mesCadena+'-'+date.getDate());
            this.registerForm.get('fechaNacimiento')?.setValue(date);
            }else{
              console.log('fecha es: ',x.fechaNacimiento);
            }

          }
        });
        //  this.registerForm.get('estado')?.setValue(this.dataInput.estado);
      }
    });

    this.configSvc.getReglasEmpresa().subscribe(res=>{
      console.log(res);
      if(res.emailRequerido){
        this.registerForm.get('email')?.addValidators([Validators.required,Validators.email]);
        console.log('validadores agregados')
      }else{
        this.registerForm.get('email')?.clearValidators();  
      }

    })


  }

  getErrorMessageEmail() {
    if (this.registerForm.get('email')?.hasError('email')) {
      return 'No es un email valido';
    }
    return '';
  }

  guardar() {
    console.log('guardar usuario');
    console.log('deportista: ', this.registerForm.value);
    if (this.isForEdit) {
      //aqui mando a editar

        if (this.registerForm.get('fechaNacimiento')?.value == '') {
        this.registerForm.get('fechaNacimiento')?.setValue(null);
      }
      this.usrSvc.editarDeportista(this.registerForm.value).subscribe((res) => {
        console.log('resultado EditarUsuario: ', res);
        if (res) {
          this.alertify.success('Deportista actualizado correctamente');
          this.dialogRef.close();
        } else {
          this.alertify.error('El deportista no se ha podido actualizar, el número de documento del deportista puede estar duplicado, valide la información e intentelo de nuevo');
        }
      });
    } else {
      //aqui mando a crearlo
      this.registerForm
        .get('id')
        ?.setValue('00000000-0000-0000-0000-000000000000');
      //  this.registerForm.get('estado')?.setValue(0);
      this.registerForm
        .get('sexo')
        ?.setValue(Number(this.registerForm.get('sexo')?.value));

      if (this.registerForm.get('fechaNacimiento')?.value == '') {
        this.registerForm.get('fechaNacimiento')?.setValue(null);
      }

      this.usrSvc.createDeportista(this.registerForm.value).subscribe((res) => {
        console.log('resultado crear: ', res);

        switch (res) {
          case 1:
            this.alertify.success('Deportista creado correctamente');
            this.dialogRef.close();
            break;
          case 2:
            this.alertify.error(
              'El número de documento ya existe, valide la información e intentelo de nuevo'
            );
            break;
        }
      });
    }
  }
}
